import { createAsyncThunk } from "@reduxjs/toolkit";
import { auth } from "../../firebase/config";
import { signInWithEmailAndPassword } from "firebase/auth";

interface IAuth {
  email: string;
  password: string;
}

interface ISignInResponse {
  userName: string;
  token: string;
  message: string;
  userEmail: string;
  uid: string;
}

interface IRejectValue {
  message: string;
}

export const signIn = createAsyncThunk<
  ISignInResponse,
  IAuth,
  { rejectValue: IRejectValue }
>("auth/signIn", async (data, thunkAPI) => {
  try {
    const UserCredential = await signInWithEmailAndPassword(
      auth,
      data.email,
      data.password
    );

    return {
      userName: UserCredential.user.displayName ?? "",
      token: await UserCredential.user.getIdToken(),
      message: "Sign in successful",
      userEmail: UserCredential.user.email ?? "",
      uid: UserCredential.user.uid
    };
  } catch (error) {
    if (error instanceof Error) {
      console.log(error?.message);
      if (error.message === "Firebase: Error (auth/invalid-credential).") {
        return thunkAPI.rejectWithValue({
          message: "Invalid Email or Password"
        });
      }
    }
    return thunkAPI.rejectWithValue({
      message: "Something went wrong"
    });
  }
});
